// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//完整引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//签名组件
import vueEsign from 'vue-esign'
Vue.use(vueEsign)

import VueTreeselect from 'vue-treeselect';
Vue.component('VueTreeselect', VueTreeselect);
import _ from 'lodash';// 导入loadsh
Vue.prototype.$lodash = _;

//引入md5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import '@/icons'

//项目stroe
import store from './store/index.js'
Vue.prototype.$store = store

//ant-design-vue css   本项目引入了部分的ant-design-vue组件
import 'ant-design-vue/dist/antd.css';
Vue.config.productionTip = false

//引入流程组件
import CrownBootFlowVue from '@/components/packages/index'
Vue.use(CrownBootFlowVue);
import Crownboot from 'crownboot-antd-vue';
Vue.use(Crownboot);

//流程设计器单独设立store
import storeProcess from './storeProcess'
Vue.prototype.$storeProcess = storeProcess

//请求 用于为组件单独设置请求
import request from '@/utils/request.js'
Vue.prototype.$axios = request

//ant-design-vue的message方法
import { message } from 'ant-design-vue';
Vue.prototype.$toast = message

import Pagination from "@/components/Pagination/index";
Vue.component('Pagination', Pagination);


Vue.prototype.$deepClone = function deepClone (obj) {
  let objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === "object") {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        //判断ojb子元素是否为对象，如果是，递归复制
        if (obj[key] && typeof obj[key] === "object") {
          objClone[key] = deepClone(obj[key]);
        } else {
          //如果不是，简单复制
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
};


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  storeProcess,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js